import { render, staticRenderFns } from "./calls.vue?vue&type=template&id=7c2990c4&scoped=true"
import script from "./calls.vue?vue&type=script&lang=js"
export * from "./calls.vue?vue&type=script&lang=js"
import style0 from "./calls.vue?vue&type=style&index=0&id=7c2990c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2990c4",
  null
  
)

export default component.exports